import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { isAuthenticated } from './utils/auth';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import Translations from './pages/Translations';
import AdminPanel from './pages/AdminPanel';
import Dictionary from './pages/Dictionary';
import './index.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
    return isAuthenticated() ? children : <Navigate to="/login" />;
};

function App() {
    return (
        <LanguageProvider>
            <Router>
                <Routes>
                    <Route 
                        path="/login" 
                        element={isAuthenticated() ? <Navigate to="/dashboard" /> : <Login />} 
                    />
                    <Route 
                        path="/dashboard" 
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        } 
                    />
                    <Route 
                        path="/projects" 
                        element={
                            <ProtectedRoute>
                                <Projects />
                            </ProtectedRoute>
                        } 
                    />
                    <Route 
                        path="/translations/:projectId" 
                        element={
                            <ProtectedRoute>
                                <Translations />
                            </ProtectedRoute>
                        } 
                    />
                    <Route 
                        path="/dictionary" 
                        element={
                            <ProtectedRoute>
                                <Dictionary />
                            </ProtectedRoute>
                        } 
                    />
                    <Route 
                        path="/admin" 
                        element={
                            <ProtectedRoute>
                                <AdminPanel />
                            </ProtectedRoute>
                        } 
                    />
                    <Route path="/" element={<Navigate to="/dashboard" />} />
                </Routes>
            </Router>
        </LanguageProvider>
    );
}

export default App;

